import { Flex, styled } from '@driftt/dds'

export const FirstExperienceContentBody = styled(Flex, {
  minHeight: '74px',
})

export const FirstExperienceContentImageContainer = styled(Flex, {
  minHeight: '296px',
  background: '$gray2',
})
